import axios from 'axios';


const IS_DEV = process.env.NODE_ENV === 'development';
const $host = axios.create({
  baseURL: !IS_DEV ? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL_DEV
});

const authInterceptor = config => {
  const token = localStorage.getItem('authorization');
  if (token) {
    config.headers.authorization = 'Bearer ' + token;
  }
  return config;
};

$host.interceptors.request.use(authInterceptor);

export { $host };
